import { toJS, observable, action, runInAction } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api";
import { formatStoreCateTree, formatTableKey } from "../../utils/common";
const { shop } = api;

class ShopStore {
  // 获取地址库-供应链
  @action async getAddress(params) {
    const { data } = await httpClient.post(shop.GET_ADDRESS, { ...params });
    return data;
  }

  // 匹配商品库存
  @action async getStocks(params) {
    const localList = [...params.list];
    for (const row of localList) {
      for (const {
        spuId,
        stock,
        stockStateId,
      } of params.data.stockList.values()) {
        if (spuId === row.spuId) {
          row["stock"] =
            stock > 0 ? stock : stockStateId === 1 ? "有货" : "无货";
        }
      }
    }
    return localList;
  }

  // 京东商品改价-点击手动爬虫获取当前市场价-单个商铺
  @action async getNewMarketPrice(params) {
    const { data } = await httpClient.get(shop.GET_NEW_MARKET_PRICE, {
      params,
    });
    this.priceRuleInfo.marketPrice = data;
    // this.priceRuleInfo.marketPrice = 20000
  }

  // 更新市场价-多个商品
  @action async updateMulMarketPrice(params) {
    return httpClient.post(shop.GET_NEW_MARKET_PRICE_MUL, { ...params });
  }

  /**
   * 审核商品商品库
   * **/

  // 京东商品列表
  @observable productsListJD = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  // 自营商品列表
  @observable productsListSelf = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };

  // 获取京东商品库，列表
  @action async getJDStoreList(params) {
    // 1审核商品商品库， 2已挑选商品库
    let _data;
    switch (params.platform) {
      case 1:
        _data = await httpClient.post(shop.GET_JD_STORE_LIST, { ...params });
        break;
      case 2:
        _data = await httpClient.post(shop.GET_ELESTORE_JD_LIST, { ...params });
        break;
    }

    const { data } = _data;
    this.productsListJD = {
      list: formatTableKey(data.list),
      pages: {
        total: data.total,
        pageSize: params.pageSize,
        currentPage: data.page,
      },
    };
    return data;
  }

  // 获取京东商品库存
  @action async getGoodsStock(params) {
    const { data } = await httpClient.post(shop.GET_STOCKS, { ...params });
    const { list, pages } = this.productsListJD;
    const newList = await this.getStocks({ data, list, pages });
    runInAction(() => {
      this.productsListJD.list = newList;
    });
  }

  @observable elestoreShopList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  // 获取京东商品库存
  @action async getElestoreShopList(params) {
    const { data } = await httpClient.post(shop.GET_ELESTORE_SHOP_LIST, {
      ...params,
    });
    if (data) {
      this.elestoreShopList = {
        list: formatTableKey(data.list),
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  // 获取采购商城商品库-自营，列表
  @action async getSelfStoreList(params) {
    // 1审核商品商品库， 10采购商城商品库, 11卡券商城
    let _data;
    switch (params.platform) {
      case 1:
        _data = await httpClient.post(shop.GET_SELF_STORE_LIST, { ...params });
        break;
      case 10:
        _data = await httpClient.post(shop.GET_SELF_PURCHASE_STORE_LIST, {
          ...params,
        });
        break;
    }

    const { data } = _data;
    this.productsListSelf = {
      list: formatTableKey(data.list),
      pages: {
        total: data.total,
        pageSize: params.pageSize,
        currentPage: data.page,
      },
    };
  }

  // 京东改价规则回显
  @observable priceRuleInfo = {
    apiToShopParamInfo: {
      stairParamList: [],
    },
  };
  // 自营改价规则回显
  @observable selfPriceRuleInfo = {};

  // 获取弹窗调价规则回显信息
  @action async getPriceRule(params) {
    if (params.supplierPlatform === "jd") {
      const { data } = await httpClient.post(shop.GET_JD_PRICE_RULE, {
        ...params,
      });
      this.priceRuleInfo = {
        ...data,
        apiToShopParamInfo: data.apiToShopParamList[0]
          ? toJS(data.apiToShopParamList[0])
          : { stairParamList: [] },
      };
    } else if (params.supplierPlatform === "self") {
      const { data } = await httpClient.post(shop.GET_SELF_PRICE_RULE, {
        ...params,
      });
      this.selfPriceRuleInfo = {
        stairParamList: [],
        ...data,
      };
    }
  }

  // 重置调价-阶梯价格
  @action resetPurchaseStairPrice(params) {
    this.priceRuleInfo.apiToShopParamInfo = { stairParamList: [] };
  }
  // 重置调价-全部
  @action resetPurchasePriceRuleInfo(params) {
    this.priceRuleInfo = {
      apiToShopParamInfo: {
        stairParamList: [],
      },
    };
    this.selfPriceRuleInfo = {
      // stairParamList: []
    };
  }

  // 商城-挑选商品-提交改价
  @action sendPriceRule(params) {
    return params.supplierPlatform === "jd"
      ? httpClient.post(shop.SEND_JD_PRICE_RULE, { ...params })
      : httpClient.post(shop.SEND_SELF_PRICE_RULE, { ...params });
  }

  // 采购商城-对选择的商品批量操作 （1上架 2下架 3删除 4驳回）
  @action sendPickedGoods(params) {
    switch (params.modalType) {
      case -10:
        return httpClient.post(shop.SET_PRODUCT_ONSALE, { ...params });
        break;
      case 10:
        return httpClient.post(shop.SET_PRODUCT_OFFSALE, { ...params });
        break;
      case 30:
        return httpClient.post(shop.DEL_PRODUCT, { ...params });
        break;
      case 4:
        return httpClient.post(shop.REJECT_PRODUCT, { ...params });
        break;
    }
  }

  // 象铺-对选择的商品批量操作 （10通过，-20驳回）
  @action sendPickedEleStoreGoods(params) {
    switch (params.modalType) {
      case 10:
        return httpClient.post(shop.SET_ELESTORE_GOODS_ONSALE, { ...params });
        break;
      case -20:
        return httpClient.post(shop.SET_ELESTORE_GOODS_OFFSALE, { ...params });
        break;
    }
  }

  // 根据商铺名称搜索商铺列表
  @observable shopNameList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @action async getShopNameList(params) {
    const { data } = await httpClient.post(shop.GET_ELESTORE_SHOP_SEARCH_LIST, {
      ...params,
    });
    if (data) {
      this.shopNameList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  // 品牌
  @observable brandList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };

  // 获取品牌列表
  @action async getBrandList(params) {
    try {
      const { data } = await httpClient.post(shop.GET_BRAND_LIST, {
        ...params,
      });
      runInAction(() => {
        this.brandList = {
          list: data.list,
          pages: {
            total: data.total,
            pageSize: params.pageSize,
            currentPage: data.page,
          },
        };
      });

      return data.list || [];
    } catch (error) {
      return false;
    }
  }

  // 新增品牌
  @action updateBrand({ isAdd, ...params }) {
    return isAdd
      ? httpClient.post(shop.ADD_BRAND, { ...params })
      : httpClient.post(shop.EDIT_BRAND, { ...params });
  }

  // 删除品牌
  @action delBrand(params) {
    return httpClient.post(shop.DEL_BRAND, { ...params });
  }

  // 获取品牌下的商品数
  @action async getBrandGoodsNum(params, type) {
    const { data } = await httpClient.post(shop.GET_BRAND_GOOGS_NUM, {
      ...params,
    });
    if (type == 1) {
      // 更改state.goodsCountNum 以更新页面展示
      const _newList = this.brandList.list;
      _newList.filter(
        (item) => item.brandId === params.brandId
      )[0].goodsCountNum = data.toString();
      this.brandList.list = toJS(_newList);
    }

    return data;
  }

  // 信息变更审核
  @observable infoChangeList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @observable infoChangeDetail = {};

  // 获取信息变更审核列表
  @action async getInfoChangeList(params) {
    const { data } = await httpClient.post(shop.GET_INFO_CHANGE_LIST, {
      ...params,
    });

    if (data) {
      this.infoChangeList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  @action async getInfoChangeDetail(params) {
    const { data } = await httpClient.post(shop.GET_INFO_CHANGE_DETAIL, {
      ...params,
    });
    this.infoChangeDetail = data;
  }

  // 通过审核
  @action passInfoChange(params) {
    return httpClient.post(shop.PASS_INFO_CHANGE, { ...params });
  }

  // 驳回审核
  @action rejectInfoChange(params) {
    return httpClient.post(shop.REJECT_INFO_CHANGE, { ...params });
  }
}

export default new ShopStore();
